<template>
  <div>
    <div class="storecard-error">
      <div class="overlay">
        &nbsp;
      </div>
      <div class="outer">
        <div class="inner">
          <div class="title">
            <h3>Critical Error encounted Storing Credit Card Details</h3>
          </div>
          <div class="msg">
            <p>
              This has likely occured due
              to circumstance beyond our control, including a network outage, or interuption,
              or other system failure while the payment process was being performed.
            </p>
            <p>
              Unfortunately given the nature of the issue the system cannot
              detemine if the failure occurred before or after the credit card
              was stored into your account.
            </p>
            <p>
              You can check in the member portal see a list of your stored credit cards.
            </p>
            <p>
              Alternatively, you can contact the site admin to report the problem.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'storecard-error',
  props: {
    details: {
      type: Error,
      required: true
    }
  },
  computed: {
  }
}
</script>

<style lang='scss' scoped>

  .storecard-error .outer {
    position: relative;
    z-index: 15;
    margin: 0 auto;
    max-width:80%;
  }
  .storecard-error .inner {
    position: absolute;
    background-color: #fff;
    top: 0;
    padding: 2em;
    z-index: 20;
    text-align: center;
    width: 80%;
    border-radius: 3px;
    margin: 2em auto;
    left: 0;
    right: 0;
    box-shadow: 0px 1px 10px 0px #00000040;
  }

  .storecard-error .overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 10;
    background-color: #EEE;
  }

  .storecard-error .title {
  }

</style>
